let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8cWT4")).then(() => parcelRequire('aRs4b'));